export const Patan = {
    title: "Patan",
    title1: "(Historical & Architectural City)",

    intro: "Patan is a historic city in Gujarat, known for its rich cultural heritage, ancient architecture, and vibrant history. It is famously home to the Rani ki Vav, a UNESCO World Heritage site, and is renowned for its Patola silk weaving, an ancient craft that still thrives in the region.",

    attractions: [
        {
            name: "Rani ki Vav",
            description: "Rani ki Vav is one of the most famous stepwells in India and a UNESCO World Heritage site. Built in the 11th century, it showcases intricate sculptures, carvings, and architectural brilliance. The stepwell is designed as an inverted temple, with its beauty and grandeur offering a glimpse into the region's medieval history.",
            location: "Rani ki Vav, Patan, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "₹25 per person",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Admire the stepwell's architectural grandeur",
                "Explore the detailed carvings and sculptures",
                "Take photographs of the beautiful surroundings",
                "Learn about the history of Rani ki Vav",
                "Enjoy the peaceful atmosphere and historical site"
            ],
            mapLink: "https://maps.app.goo.gl/G7KbWq5tEowL7bRt7",
        },
        {
            name: "Sahasralinga Lake",
            description: "Sahasralinga Lake is a serene and historic lake in Patan, known for its sacred significance and picturesque surroundings. The lake is dotted with numerous Shiva lingams, making it a popular pilgrimage site.",
            location: "Sahasralinga Lake, Patan, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Relax by the lake",
                "Take photographs of the peaceful surroundings",
                "Engage in meditation and quiet reflection",
                "Explore the numerous Shiva lingams",
                "Enjoy a boat ride on the lake"
            ],
            mapLink: "https://maps.app.goo.gl/6os8JkNjNgtDEqg58",
        },
        {
            name: "Patola Heritage Museum",
            description: "The Patola Heritage Museum is dedicated to the famous Patola silk weaving technique, which originated in Patan. The museum showcases the art of weaving Patola silk sarees and the region’s long-standing tradition of textile craftsmanship.",
            location: "Patola Heritage Museum, Patan, Gujarat",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹20 per person",
            bestTimeToVisit: "Morning",
            activities: [
                "Learn about the art of Patola silk weaving",
                "Watch demonstrations of the weaving process",
                "Explore various Patola silk garments and designs",
                "Understand the historical significance of Patola",
                "Buy Patola silk products from the museum shop"
            ],
            mapLink: "https://maps.app.goo.gl/uz4S8XbcZ3j5J7t68",
        },
        {
            name: "Brahma Sarovar",
            description: "Brahma Sarovar is a sacred water body located in Patan. The serene lake is an important religious site, with temples around it dedicated to various deities. It offers a tranquil atmosphere for pilgrims and visitors seeking peace.",
            location: "Brahma Sarovar, Patan, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning",
            activities: [
                "Take a walk around the serene lake",
                "Attend prayer ceremonies by the lake",
                "Meditate in the peaceful surroundings",
                "Take a boat ride on the lake",
                "Admire the surrounding temples and architecture"
            ],
            mapLink: "https://maps.app.goo.gl/C9nP9tYxxkTzzT9s5",
        },
        {
            name: "Rudra Mahalaya Temple",
            description: "Rudra Mahalaya Temple is a historic temple dedicated to Lord Shiva, known for its grand architecture and intricate carvings. The temple was built in the 12th century and showcases the architectural brilliance of the Solanki dynasty.",
            location: "Rudra Mahalaya, Patan, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the temple and offer prayers",
                "Admire the detailed carvings and architecture",
                "Engage in spiritual activities and rituals",
                "Take photographs of the temple and its surroundings",
                "Learn about the history of the temple"
            ],
            mapLink: "https://maps.app.goo.gl/8xuF8XgjsQtgP9h6A",
        },
        {
            name: "Shree Jalaram Bapa Temple",
            description: "The Shree Jalaram Bapa Temple in Patan is dedicated to Jalaram Bapa, a revered saint of Gujarat. The temple is a place of devotion and offers a peaceful environment for spiritual reflection and worship.",
            location: "Jalaram Bapa Temple, Patan, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and aarti sessions",
                "Meditate and engage in spiritual activities",
                "Participate in community services and festivals",
                "Admire the peaceful temple surroundings",
                "Learn about the life and teachings of Jalaram Bapa"
            ],
            mapLink: "https://maps.app.goo.gl/1yQvwkRofrkBEszL7",
        },
    ]
};
